import { Purchaser, PurchaserProps } from "@/core/entities/lookup/purchaser/Purchaser";

export interface AccountingPurchaserProps extends PurchaserProps {
  qboCustomerId: number | null;
  qboCustomerName: string | null;
}

export class AccountingPurchaser extends Purchaser {
  private readonly _qboCustomerId: number | null;
  private readonly _qboCustomerName: string | null;

  constructor(props: AccountingPurchaserProps) {
    super({
      purchaserId: props.purchaserId,
      purchaserKey: props.purchaserKey,
      purchaserName: props.purchaserName,
    });
    this._qboCustomerId = props.qboCustomerId ?? null;
    this._qboCustomerName = props.qboCustomerName ?? null;
  }

  public get qboCustomerId(): number | null {
    return this._qboCustomerId;
  }

  public get qboCustomerName(): string | null {
    return this._qboCustomerName;
  }

  public get displayName(): string {
    return this.purchaserName;
  }

  public static fromJson(props: AccountingPurchaserProps): AccountingPurchaser {
    return new AccountingPurchaser(props);
  }
}
